import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { privacyHtml } from "../data/legalPrivacy";
import { agreementHtml } from "../data/legalAgreement";
import { offerHtml } from "../data/legalOffer";

type TabKey = "privacy" | "agreement" | "offer";

export const Legal: React.FC = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState<TabKey>("privacy");

  const tabs: { key: TabKey; label: string; html: string }[] = [
    { key: "privacy", label: "Политика", html: privacyHtml },
    { key: "agreement", label: "Соглашение", html: agreementHtml },
    { key: "offer", label: "Оферта", html: offerHtml },
  ];

  const active = tabs.find((t) => t.key === tab)!;

  return (
    <div style={styles.container}>
      <button style={styles.backBtn} onClick={() => navigate("/info")}>
        <ArrowLeft size={16} /> Информация
      </button>
      <h1 style={styles.title}>Справочная информация</h1>

      <div style={styles.tabRow}>
        {tabs.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            style={{
              ...styles.tabBtn,
              ...(tab === t.key ? styles.tabBtnActive : {}),
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="legal-content" style={styles.legalText} dangerouslySetInnerHTML={{ __html: active.html }} />

      <style>{`
        .legal-content p { margin: 0 0 10px 0; }
        .legal-content h2 { font-size: 15px; margin: 16px 0 8px 0; color: var(--tg-theme-text-color, #000); }
        .legal-content ul { margin: 0 0 10px 0; padding-left: 20px; }
        .legal-content li { margin-bottom: 4px; }
        .legal-content table { border-collapse: collapse; width: 100%; margin-bottom: 12px; font-size: 12px; }
        .legal-content th, .legal-content td { border: 1px solid var(--tg-theme-hint-color, #ccc); padding: 6px; text-align: left; }
      `}</style>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: { padding: "16px", maxWidth: "480px", margin: "0 auto" },
  backBtn: { display: "flex", alignItems: "center", gap: "6px", background: "none", border: "none", color: "var(--tg-theme-link-color, #2481cc)", fontSize: "14px", cursor: "pointer", padding: 0, marginBottom: "12px" },
  title: { fontSize: "20px", fontWeight: 700, margin: "0 0 14px 0", color: "var(--tg-theme-text-color, #000)" },
  tabRow: { display: "flex", gap: "6px", marginBottom: "16px" },
  tabBtn: { flex: 1, padding: "8px", borderRadius: "10px", border: "none", backgroundColor: "var(--tg-theme-secondary-bg-color, #fff)", color: "var(--tg-theme-text-color, #000)", fontSize: "13px", cursor: "pointer" },
  tabBtnActive: { backgroundColor: "var(--tg-theme-button-color, #2481cc)", color: "var(--tg-theme-button-text-color, #fff)" },
  legalText: { fontSize: "13px", lineHeight: 1.6, color: "var(--tg-theme-text-color, #000)" },
};
